/* Corrige le libellé « Couleur : … » : affiche la valeur réellement cochée */
(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  function fix() {
    document.querySelectorAll('[data-selected-for]').forEach(function (label) {
      var pos = label.dataset.selectedFor;
      var input = form.querySelector('[data-option-position="' + pos + '"]:checked') || form.querySelector('select[data-option-position="' + pos + '"]');
      if (input) label.textContent = input.value;
    });
  }
  form.addEventListener('change', function () { setTimeout(fix, 0); });
  fix();
})();
